<template>
  <div>
    <el-upload
      :action="url"
      :headers="headers"
      :multiple="multiple"
      name="uploadFile"
      :data="{
        asImage: asImage,
        fieldName: fieldName,
        model: uplaodModel,
      }"
      :on-success="handleAvatarSuccess"
      :on-change="handleAvatarChange"
      :show-file-list="false"
    >
      <el-button
        :loading="loading"
        :disabled="loading"
        type="primary"
        :icon="icon"
        :size="size"
        >更新导入</el-button
      >
    </el-upload>
    <!-- <el-button
      :loading="loading"
      :disabled="loading"
      type="primary"
      :icon="icon"
      :size="size"
      @click="importClick()"
      >更新导入</el-button
    > -->
    <el-dialog
      :visible.sync="dialogState.show1"
      :close-on-click-modal="false"
      :title="'更新导入'"
      append-to-body
      @close="dialogClose"
      width="861px"
    >
      <div style="width: 92%; margin-left: 8%">
        <el-radio-group v-model="radio">
          <el-radio
            v-for="(item, index) in titleList"
            :key="index"
            :label="item.keyValueEn"
            >{{ item.keyNameCn }}</el-radio
          >
        </el-radio-group>
      </div>
      <div style="margin: 20px; text-align: center">
        <el-upload
          :action="url"
          :headers="headers"
          :multiple="multiple"
          name="uploadFile"
          :data="{
            asImage: asImage,
            fieldName: fieldName,
            model: uplaodModel,
          }"
          :on-success="handleAvatarSuccess"
          :on-change="handleAvatarChange"
          :show-file-list="false"
          style="display: inline-block; margin-right: 10px"
        >
          <el-button type="primary">更新导入</el-button>
        </el-upload>
        <el-button @click="dialogClose">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import projectConfig from "@/core/config";
import { getToken } from "@/utils";
export default {
  props: {
    // 更新导入的参数
    importTitleList: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
    // 图标
    icon: {
      type: Object,
      default: "el-icon-paperclip",
    },
    // 上传模块
    size: {
      type: Object,
      default: "small",
    },
    // 上传模块
    uplaodModel: {
      type: Object,
      default: "",
    },
    // 导入路径
    url: {
      type: String,
      default: projectConfig.baseUrl + "qingguang/cooperativesupplier/common/uploadDoc",
    },
    // 是否允许多个文件上传
    multiple: {
      type: Boolean,
      default: false,
    },
    // 文件类型是否是图片
    asImage: {
      type: Boolean,
      default: false,
    },
    fieldName: {
      type: String,
      default: "文件",
    },
  },
  data() {
    return {
      // projectConfig.baseUrl + "qingguang/tenantbussiness/common/upload",
      headers: { Authorization: getToken() },
      loading: false,
      radio: null,
      dialogState: {
        show1: false,
      },
      //   导出需要的列表参数
      titleList: [],
    };
  },
  created() {},
  methods: {
    importClick() {
      this.titleList = [];
      this.importTitleList.forEach(async (item) => {
        if (item.isShow === true) {
          if (item.value.indexOf("-ext") > -1) {
          } else {
            let json = {
              keyNameCn: item.name,
              keyValueEn: item.value,
            };
            this.titleList.push(json);
          }
        }
      });
      this.dialogState.show1 = true;
    },
    dialogClose() {
      this.dialogState.show1 = false;
      this.radio = null;
      this.btnLoading = false;
    },
    handleAvatarSuccess(res, file) {
      this.$emit("handleAvatarSuccess", res, file);
    },
    handleAvatarChange(file, fileList) {
      this.loading = true;
      if (file.percentage == 100) {
        this.loading = false;
        this.$emit("handleAvatarChange", file);
      }
    },
  },
};
</script>
<style lang="less" scoped>
::v-deep .el-radio {
  width: 20%;
}
</style>
